/* Bisou Studio v3 : menus déroulants, taille du texte, fenêtre de bienvenue, points Club sur la fiche produit.
   Complète theme.js (même style : fonctions simples, stockage « bisou_* » dans le navigateur). */
(function () {
  'use strict';
  var B = window.BISOU || {};
  var R = B.routes || { root: '/' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem('bisou_' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem('bisou_' + k, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } }
  };

  /* ---------- Menus déroulants (souris, clavier, téléphone) ---------- */
  function setSub(btn, open) {
    var sub = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open);
    if (sub) sub.hidden = !open;
  }
  function closeSubs(except) {
    $$('.nav__toggle[aria-expanded="true"]').forEach(function (b) { if (b !== except) setSub(b, false); });
  }
  function initNav() {
    var nav = $('#nav'); if (!nav) return;
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.nav__toggle'); if (!btn) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeSubs(btn); setSub(btn, open);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('#nav')) closeSubs(); });
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var item = e.target.closest('.nav__item'); if (!item) return;
      var btn = $('.nav__toggle', item);
      if (btn.getAttribute('aria-expanded') === 'true') { setSub(btn, false); btn.focus(); e.stopPropagation(); }
    });
    nav.addEventListener('focusout', function (e) {
      var item = e.target.closest('.nav__item');
      if (item && !item.contains(e.relatedTarget) && window.matchMedia('(min-width: 861px)').matches) setSub($('.nav__toggle', item), false);
    });
  }

  /* ---------- Texte plus grand (A+) ---------- */
  function paintText() {
    var on = document.documentElement.dataset.text === 'lg';
    $$('[data-text-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', on);
      if (b.id === 'textBtn') b.setAttribute('aria-label', on ? 'Revenir à la taille de texte normale' : 'Agrandir le texte');
    });
  }
  function initTextSize() {
    paintText();
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-text-toggle]')) return;
      var html = document.documentElement, on = html.dataset.text === 'lg';
      if (on) delete html.dataset.text; else html.dataset.text = 'lg';
      store.set('text', on ? null : 'lg'); paintText();
    });
  }

  /* ---------- Mode sombre depuis le pied de page (le bouton lune de l'en-tête est géré par theme.js) ---------- */
  function paintMode() {
    var dark = document.documentElement.dataset.mode === 'dark';
    $$('[data-mode-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', dark); });
    var mb = $('#modeBtn');
    if (mb) { mb.setAttribute('aria-pressed', dark); mb.setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode sombre'); }
  }
  function initMode() {
    paintMode();
    document.addEventListener('click', function (e) {
      if (e.target.closest('#modeBtn')) { setTimeout(paintMode, 0); return; }
      if (!e.target.closest('[data-mode-toggle]')) return;
      var html = document.documentElement;
      html.dataset.mode = html.dataset.mode === 'dark' ? 'light' : 'dark';
      store.set('mode', html.dataset.mode); paintMode();
    });
  }

  /* ---------- Onglets Femmes / Hommes ---------- */
  var EQUIV = { femme: { 'bijoux-homme': 'bijoux', 'lunettes-homme': 'lunettes' }, homme: { boucles: 'bijoux-homme', bijoux: 'bijoux-homme', lunettes: 'lunettes-homme' } };
  function initUnivers() {
    var u = document.documentElement.dataset.univers || 'femme';
    var links = $$('[data-univers-link]'), hommeHome = null;
    links.forEach(function (a) {
      if (a.dataset.universLink === 'homme') hommeHome = a.getAttribute('href');
      if (a.dataset.universLink === u) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      a.addEventListener('click', function () { store.set('univers', a.dataset.universLink); });
    });
    /* Onglet de l'autre univers : catégorie équivalente quand elle existe (ex. Lunettes femmes -> Lunettes hommes) */
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (m) {
      links.forEach(function (a) {
        var target = EQUIV[a.dataset.universLink] && EQUIV[a.dataset.universLink][m[1]];
        if (target) a.setAttribute('href', R.root + 'collections/' + target);
      });
    }
    if (u !== 'homme' || !hommeHome) return;
    /* Univers Hommes : logo, fil d'Ariane et recherches proposées de l'univers */
    var logo = $('.header .logo'); if (logo) logo.setAttribute('href', hommeHome);
    $$('.crumbs a').forEach(function (a) { if (a.getAttribute('href') === R.root) a.setAttribute('href', hommeHome); });
    var form = $('#searchForm'); if (form && form.dataset.trendsHomme) form.dataset.trends = form.dataset.trendsHomme;
  }

  /* ---------- Visite venue d'une pub ----------
     Repérée par l'adresse (utm_*, ScCid, fbclid, gclid, ttclid) ou la provenance (Snapchat, Facebook, Instagram, TikTok),
     puis mémorisée pour toute la visite (sessionStorage). Les pages vues de la visite sont comptées au même endroit. */
  function sess(k, v) { try { if (v === undefined) return sessionStorage.getItem('bisou_' + k); sessionStorage.setItem('bisou_' + k, v); } catch (e) { return null; } }
  function fromAd() {
    if (sess('ad') === '1') return true;
    var ad = /[?&](utm_source|utm_medium|ScCid|sccid|fbclid|gclid|ttclid)=/.test(location.search) || /snapchat|facebook|instagram|tiktok/i.test(document.referrer);
    if (ad) sess('ad', '1');
    return ad;
  }
  function countView() { var n = (+sess('pv') || 0) + 1; sess('pv', n); return n; }

  /* ---------- Fenêtre de bienvenue ----------
     Jamais pendant une visite venue d'une pub : la visiteuse doit d'abord voir les produits (les fenêtres à l'arrivée
     faisaient fuir le trafic Snap). Sinon, une seule fois : après 30 s, ou au défilement (60 %) à partir de la 2e page vue
     (sur une page courte, 60 % est atteint tout de suite). */
  function initWelcome() {
    var ad = fromAd(), views = countView();
    var d = $('#welcome'); if (!d || typeof d.showModal !== 'function') return;
    var posted = /customer_posted=true/.test(location.search) && ($('[data-welcome-success]', d) || $('[data-welcome-error]', d));
    var excluded = ['cart', 'customers/account', 'customers/login', 'customers/register', 'password', 'gift_card'].indexOf(B.template) > -1 || B.suffix === 'club' || /^customers/.test(B.template || '');
    var lastFocus = null, timer = null;
    function open() {
      if (d.open) return;
      lastFocus = document.activeElement; d.hidden = false; d.showModal(); store.set('welcome', true);
      window.removeEventListener('scroll', onScroll); clearTimeout(timer);
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.6) open();
    }
    d.addEventListener('close', function () { store.set('welcome', true); if (lastFocus && document.contains(lastFocus)) lastFocus.focus(); });
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-welcome-close]')) d.close();
    });
    if (posted) { open(); return; }
    if (excluded || ad || store.get('welcome', false)) return;
    timer = setTimeout(open, 30000);
    if (views >= 2) window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Fiche produit : points selon la variante choisie ---------- */
  function initPoints() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-option]')) return;
      var root = e.target.closest('[data-product-form]'); if (!root) return;
      var data = $('[data-variants]', root), out = $('[data-points]', root.parentNode); if (!data || !out) return;
      var variants = []; try { variants = JSON.parse(data.textContent); } catch (err) { return; }
      var chosen = [];
      $$('input[data-option]:checked', root).forEach(function (i) { chosen[+i.dataset.option - 1] = i.value; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      if (v) out.textContent = Math.floor(v.price / 100);
    });
  }

  function init() { initUnivers(); initNav(); initTextSize(); initMode(); initWelcome(); initPoints(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
